module.exports = __webpack_public_path__ + "static/img/5en.13e3c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/5en.png
// module id = lWlp
// module chunks = 0